export const DAYS_TO_HIDE_REMAINING_BUDGET = 61
export const EXPIRATION_DATE_BUFFER_DAYS = 16
